<template>
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.1228 0.569531C1.69013 0.626213 0.375 1.79506 0.375 3.36982V22.6301C0.375 24.7298 2.71422 26.1074 4.55103 25.0898L21.9314 15.4597C23.821 14.4126 23.821 11.5873 21.9314 10.5402L4.55103 0.910108C4.09182 0.655711 3.60036 0.550638 3.1228 0.569531Z"
            fill="white"
        />
    </svg>
</template>
